import { IInitialState } from 'store/models';
import { mainStateSelector } from './mainStateSelector';

export function isNavbarOpenedSelector(state: IInitialState) {
	return mainStateSelector(state).isNavbarOpened;
}
